/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CreateRecourseCriteriaRestRequest } from '../../models/create-recourse-criteria-rest-request';
import { CreateRecourseCriteriaRestResponse } from '../../models/create-recourse-criteria-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface CreateRecourseCriteria$Params {
  body: CreateRecourseCriteriaRestRequest;
}

export function createRecourseCriteria(
  http: HttpClient,
  rootUrl: string,
  params: CreateRecourseCriteria$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<CreateRecourseCriteriaRestResponse>> {
  const rb = new RequestBuilder(rootUrl, createRecourseCriteria.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateRecourseCriteriaRestResponse>;
    }),
  );
}

createRecourseCriteria.PATH = '/recourse-criteria';
